// extracted by mini-css-extract-plugin
export default {"form":"form_form__R3sWf","spanner":"form_spanner__lN7Hq"};